import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid'
import {
  add,
  eachDayOfInterval,
  endOfMonth,
  format,
  getDay,
  isEqual,
  isSameDay,
  isSameMonth,
  isToday,
  parse,
  parseISO,
  startOfToday, 
  startOfWeek, 
  lastDayOfWeek,
  getWeek, 
  compareAsc
} from 'date-fns'
import { useState, useEffect } from 'react'
import { getServiceMonthlySchedule } from '../API/ServiceAPI'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function DatePicker(props) {

  const [today, setToday] = useState(("today" in props) ? props.today : startOfToday())
  const [selectedDay, setSelectedDay] = useState(("selectedDate" in props) ? props.selectedDate : today)
  const [currentMonth, setCurrentMonth] = useState(format(today, 'MMM-yyyy'))
  const [availableDates, setAvailableDates] = useState([])
  const [canNext, setCanNext] = useState(true)
  const [canPrev, setCanPrev] = useState(true)
  const [scheduleClosedList, setScheduleClosedList] = useState(("scheduleClosedList" in props) ? props.scheduleClosedList : [])


  useEffect(() => {
    props.onDaySelected(selectedDay)
  }, [selectedDay])

  useEffect(() => {
    /* get available dates in current month */
    // props.loadData(
    //   parse(currentMonth, 'MMM-yyyy', new Date()), 
    //   (dates) => setAvailableDates(dates)
    // )
    
    /* get available dates in prev month */
    // props.loadData(
    //   add(parse(currentMonth, 'MMM-yyyy', new Date()), { months: -1 }), 
    //   (dates) => setCanPrev(dates.length > 0 && compareAsc(
    //     parse(dates.pop(), "yyyy-MM-dd", new Date()), today) >= 0)
    // )
    
    // /* get available dates in next month */
    // props.loadData(
    //   add(parse(currentMonth, 'MMM-yyyy', new Date()), { months: 1 }), 
    //   (dates) => setCanNext(dates.length > 0)
    // )
  }, [currentMonth])
  
  let firstDayCurrentMonth = parse(currentMonth, 'MMM-yyyy', new Date())
  let lastDayCurrentMonth = endOfMonth(firstDayCurrentMonth)
  let firstWeekCurrentMonth = getWeek(firstDayCurrentMonth)
  let lastWeekCurrentMonth = getWeek(lastDayCurrentMonth)

  let days = eachDayOfInterval({
    start: startOfWeek(firstDayCurrentMonth),
    end: lastDayOfWeek(lastDayCurrentMonth),
  })

  function previousMonth() {
    if (canPrev) {
      let prevMonth = add(
        parse(currentMonth, 'MMM-yyyy', new Date()), { months: -1 }
      )
      setCurrentMonth(format(prevMonth, 'MMM-yyyy'))
    }
  }

  function nextMonth() {
    if (canNext) {
      let nextMonth = add(
        parse(currentMonth, 'MMM-yyyy', new Date()), { months: 1 }
      )
      setCurrentMonth(format(nextMonth, 'MMM-yyyy'))
    }
  }

  const checkDateRange = (dateString) => {
    const inputDate = new Date(dateString);
    let endDate;
    // console.log('today', today);
    // console.log('mounth', today.getMonth());
    // console.log('year', today.getFullYear());
    // if (today.getMonth() === 9 && today.getFullYear() === 2025) {
    //   endDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    // } else {
      endDate = new Date(today);
      endDate.setDate(today.getDate() + 14);
    // }
    const formattedInputDate = format(dateString, 'yyyy-MM-dd')
    if (inputDate >= today && inputDate < endDate) {
      return true && !scheduleClosedList.some(item => item.date_closed === formattedInputDate);
    } else {
      return false;
    }
  };

  function isAvailable(day) {
    return checkDateRange(day);
    // return true;
  }

  function isDisabled(day) {
    return !isAvailable(day);
    // return false;
  }

  function handlerDayClicked(day) {
    isAvailable(day) && setSelectedDay(day);
  }

  return (
    <div className="rounded-xl border border-primaryRed  p-4">
      <div className="pt-2 max-w-md mx-auto md:max-w-2xl">
        <div className="">
          {/* <div className="md:grid md:grid-cols-2 md:divide-x md:divide-gray-200"> */}
          {/* <div className="md:pr-14"> */}
          <div className="">
            <div className="flex items-center">
              
              <button
                type="button"
                onClick={previousMonth}
                className={classNames(
                  'flex flex-none items-center justify-center', 
                  '-my-1.5 rounded-lg p-2 text-gray-100 hover:text-gray-200', 
                  canPrev ? 'bg-primaryRed' : 'bg-gray-300'
                )}
              >
                <span className="sr-only">Previous month</span>
                <ChevronLeftIcon className="w-4 h-4" aria-hidden="true" />
              </button>
              <h2 className="flex-auto text-center font-semibold text-gray-900">
                {format(firstDayCurrentMonth, 'MMMM yyyy')}
              </h2>
              <button
                onClick={nextMonth}
                type="button"
                className={classNames(
                  'flex flex-none items-center justify-center', 
                  '-my-1.5 rounded-lg p-2 text-gray-100 hover:text-gray-200', 
                  canNext ? 'bg-primaryRed' : 'bg-gray-300'
                )}
              >
                <span className="sr-only">Next month</span>
                <ChevronRightIcon className="w-4 h-4" aria-hidden="true" />
              </button>
            </div>
            <div className="grid grid-cols-7 mt-5 text-xs leading-6 text-center text-gray-500 font-bold">
              <div>Min</div>
              <div>Sen</div>
              <div>Sel</div>
              <div>Rab</div>
              <div>Kam</div>
              <div>Jum</div>
              <div>Sab</div>
            </div>
            <div className="grid gap-px grid-cols-7 mt-2 text-sm bg-white">
              {days.map((day, dayIdx) => (
                <div
                  key={day.toString()}
                  className={classNames(
                    dayIdx === 0 && colStartClasses[getDay(day)],
                    'aspect-square', '-m-px', 'border', 'border-[#88707070]', 
                    getWeek(day) === firstWeekCurrentMonth && getDay(day) === 0 && 'rounded-tl-xl', 
                    getWeek(day) === firstWeekCurrentMonth && getDay(day) === 6 && 'rounded-tr-xl', 
                    getWeek(day) === lastWeekCurrentMonth && getDay(day) === 0 && 'rounded-bl-xl', 
                    getWeek(day) === lastWeekCurrentMonth && getDay(day) === 6 && 'rounded-br-xl', 
                    'flex', 'justify-center', 'items-center', 
                    isDisabled(day) && 'bg-gray-300'
                  )}
                >
                  <button
                    type="button"
                    onClick={() => { handlerDayClicked(day); }}
                    className={classNames(
                      isEqual(day, selectedDay) && 'text-white', 
                      !isEqual(day, selectedDay) &&
                      isToday(day) &&
                      'text-red-500',
                      !isEqual(day, selectedDay) &&
                      !isToday(day) &&
                      isSameMonth(day, firstDayCurrentMonth) &&
                      'text-gray-900',
                      !isEqual(day, selectedDay) &&
                      !isToday(day) &&
                      !isSameMonth(day, firstDayCurrentMonth) &&
                      'text-gray-400',
                      isEqual(day, selectedDay) && isToday(day) && 'bg-primaryRed',
                      isEqual(day, selectedDay) &&
                      !isToday(day) &&
                      'bg-primaryRed',
                      !isEqual(day, selectedDay) && 'hover:bg-gray-200',
                      (isEqual(day, selectedDay) || isToday(day)) &&
                      'font-semibold',
                      'mx-auto flex h-8 w-8 items-center justify-center rounded-lg' 
                    )}
                  >
                    <time dateTime={format(day, 'yyyy-MM-dd')}>
                      {format(day, 'd')}
                    </time>
                  </button>

                  {false && (
                    <div className="w-1 h-1 mx-auto mt-1">
                      <div className="w-1 h-1 rounded-lg bg-sky-500"></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          {/* <section className="mt-12 md:mt-0 md:pl-14">
            <h2 className="font-semibold text-gray-900">
              Schedule for{' '}
              <time dateTime={format(selectedDay, 'yyyy-MM-dd')}>
                {format(selectedDay, 'MMM dd, yyy')}
              </time>
            </h2>
            <ol className="mt-4 space-y-1 text-sm leading-6 text-gray-500">
              {selectedDayMeetings.length > 0 ? (
                selectedDayMeetings.map((meeting) => (
                  <Meeting meeting={meeting} key={meeting.id} />
                ))
              ) : (
                <p>No meetings for today.</p>
              )}
            </ol>
          </section> */}
        </div>
      </div>
    </div>
  )
}

let colStartClasses = [
  '',
  'col-start-2',
  'col-start-3',
  'col-start-4',
  'col-start-5',
  'col-start-6',
  'col-start-7',
]
